import { Box, Divider, Stack } from "@mui/material";
import { Fragment } from "react";

export function PositionInfoTooltipTitle({
    portfolioInfo = [],
}: {
    portfolioInfo?: string[];
}){
    return(
        <Fragment>
            <Box sx={{fontSize: "13px", fontWeight: "600"}}>Position details</Box>
            <Divider sx={{ paddingTop: "5px", borderColor: '#f2f3f3' }}/>
            {portfolioInfo.length > 0 &&
                <Stack direction="row" alignItems="flex-start" sx={{fontSize: "13px", paddingTop: "5px"}}>
                    <Box width="70px" flexShrink={0}>Portfolio</Box>
                    <Box>
                        {portfolioInfo.map(info => <Box key={info}>{info}</Box>)}
                    </Box>
                </Stack>
            }
        </Fragment>
    );
}
